const IS_BROWSER = process.env.JUPITER_TARGET === 'browser';
const MOUNT_ID = 'root';
const ROUTER_BASE_NAME= '';
const getRouterBaseName = null


import { createApp, bootstrap } from  '@jupiter/plugin-runtime';
import { router} from "@jupiter/plugin-runtime/plugins";

import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import App from '@_jupiter_src/App';
import { ThemeProvider } from '@jupiter/plugin-runtime/styled';

let AppWrapper = null;

const renderApp = () => {
  
};

renderApp();




let ModuleApp = null;

export function provider({ basename, dom, ...props }) {
  return {
    render({ basename, dom }) {
      bootstrap(
        createApp({
		plugins: [
		router({ basename, getRouterBaseName, ...{...undefined,  ...App?.config?.features?.router}, }),
	],
})(
            (appProps) => <App {...{...appProps, ...props, basename}} />
        ),
      dom,
      );
    },
    destroy({ dom }) {
      
      if (dom) {
        unmountComponentAtNode(dom);
      }
    },
    jupiter_submodule_app_key: (props) => {
        const { _ssrData } = props;
        const WrappedApp = ModuleApp || createApp(
          {
		plugins: [
		router({ basename, _ssrData, getRouterBaseName, ...{...undefined,  ...App?.config?.features?.router}, }),
	],
}
        )(
          App
        );

        if (typeof window !== 'undefined') {
          ModuleApp = WrappedApp;

          return <WrappedApp {...props} />;
        }

        return <WrappedApp {...props}/>
      }

  };
}



